// Breadcrumb.jsx
import React from 'react';
import { Box, Breadcrumbs, Typography, Link } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import FolderIcon from '@mui/icons-material/Folder';

const Breadcrumb = ({ currentPage }) => {
  return (
    <Box sx={{ mb: 3,
    backgroundColor: '#fff',
    padding: '12px 20px',
    borderRadius: '8px',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)' }}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" sx={{ color: '#ff6600'}} />}
        aria-label="breadcrumb"
      >
        <Link
          underline="hover"
          color="inherit"
          href="/"
          sx={{ display: 'flex', alignItems: 'center', color: '#ff6600' }}
        >
          <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          Home
        </Link>

        <Typography
          color="text.primary"
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: '#ff6600',
            fontWeight: 'bold',
          }}
        >
          <FolderIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          {currentPage}
        </Typography>
      </Breadcrumbs>
    </Box>
  );
};

export default Breadcrumb;
